import type {
  AppThemeState,
  GlobalStateCommandFactory,
} from 'components/GlobalState/GlobalStateModel';
import { globalAppThemeLocalStorage } from '../globalAppThemeLocalStorage';

interface SetGlobalAppThemeCommand {
  theme: AppThemeState;
}

export const setGlobalAppTheme: GlobalStateCommandFactory<
  SetGlobalAppThemeCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.user.theme = command.theme;
  });

  globalAppThemeLocalStorage.set(command.theme);
};
